export default __webpack_public_path__ + "static/media/khadija.f39e6bc3.jpeg";